import CustomPaletteProvider from './CustomPaletteProvider';

export default {
  __init__: ['paletteProvider'],
  paletteProvider: ['type', CustomPaletteProvider],
};
